import { render, staticRenderFns } from "./EditarLaboratorioDerivado.vue?vue&type=template&id=62bf1694"
import script from "./EditarLaboratorioDerivado.vue?vue&type=script&lang=js"
export * from "./EditarLaboratorioDerivado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports